import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/modal';
import Button from '../../../refresh/atoms/button';

import Text from '../../../refresh/atoms/Text';

class AddressRemovalPopup extends Component {
  constructor(props) {
    super(props);
    this.textContent = {
      deleteMessage: 'Are you sure you want to delete the address ?',
      deletBtnText: 'OK',
      cancelBtnText: 'Cancel'
    };
  }

  render() {
    const {
      address = {},
      entryNumber = -1,
      code = '',
      modalName = '',
      luxeFlag = false
    } = this.props;

    return luxeFlag ? (
      <div className="reset-popup-container">
        <div className="card-body">
          <div className="text-container">
            <Text variant="T4" weight="bold">
              Delete Address
            </Text>
          </div>

          {/* <Text color="Dark_Grey">This address reset all the changes you have made.Procced only if you want these chanages be discarded.</Text> */}
        </div>
        <div className="reset-popup-button">
          <div className="left-button">
            <Button
              ariaLabel="DELETE"
              btnLabel="DELETE"
              variant="secondary"
              fullWidth
              onClick={() => {
                this.props.deleteAddress(modalName, {
                  entryNumber,
                  code
                });
                this.props.onCancel();
              }}
            />
          </div>
          <div className="right-button">
            <Button
              ariaLabel="CANCEL"
              btnLabel="CANCEL"
              variant="primary"
              fullWidth
              onClick={() => {
                // this.props.hideModal(modalName);
                this.props.onCancel();
              }}
            />
          </div>
        </div>
      </div>
    ) : (
      <div className="address-delete">
        <div className="delete-address delete-add-text">{this.textContent.deleteMessage}</div>
        <div className="address-delete-button">
          <div
            className="cancel-delete-btn"
            onClick={() => {
              this.props.hideModal(modalName);
            }}
            role='button'
          >
            {this.textContent.cancelBtnText}
          </div>
          <div
            className="yes-delete-btn"
            onClick={() => {
              this.props.deleteAddress(modalName, {
                entryNumber,
                code
              });
            }}
            role='button'
          >
            {this.textContent.deletBtnText}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};

export default connect(null, mapDispatchToProps)(AddressRemovalPopup);
